import React from "react";
import { ReactElement } from "react";
import * as DashboardStore from '../../store/DashboardStore';
import { connect } from 'react-redux';
import { LoggedInUser } from "../../models/LoggedInUser";
import { PolicyInfo } from "../../models/PolicyInfo";

interface CutoverSuccessProps {
    loggedInUser: LoggedInUser;
    policy: PolicyInfo;
    eligibleProgram: any;
}

interface CutoverSuccessState {
    policy: PolicyInfo,
    eligibleProgram: any,
    selectedOption: string
}


export class CutoverSuccess extends React.Component<any, CutoverSuccessState> {
    constructor(props: CutoverSuccessProps) {
        super(props);
        this.state = {
            policy: this.props.policy,
            eligibleProgram: this.props.eligibleProgram,
            selectedOption: ""
        };
    }

    async componentDidMount(): Promise<void> {
    }

    onClickExplore(): void {
        const { searchPolicyWithoutCproa, policy } = this.props;
        searchPolicyWithoutCproa(policy.policyNumber.trim(), 'Policy');
    }

    render(): ReactElement {
        return (
            <>
                <div id="cutover-success-container" style={{ display: "none" }}>
                    <div className="row cutover-success-header-row">
                        <div className="col-sm-12">
                            <div className="flexible-container success-messaging-container">
                                <div className="col-sm-1 cutover-success-icon-col">
                                    <div className="cutover-success-icon icon-confirmation"></div>
                                </div>
                                <div className="col-sm-10 cutover-success-header-col">
                                    <div className="cutover-success-message-header">You’re participating in the new DriveEasy Pro!</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row cutover-success-body-row">
                        <div className="col-sm-12">
                            <div className="cutover-success-header">Install your devices and explore your DriveEasy Pro Fleet Dashboard.</div>
                        </div>
                        <div className="col-sm-12">
                            <div className="cutover-success-list-header">1. Install Your Device(s)</div>
                            <div className="cutover-success-list-text">Your OBD device(s) will ship and arrive in 5-7 business days. Track your shipment from the dashboard.</div>
                            <div className="cutover-success-list-header">2. Track your vehicles in real-time</div>
                            <div className="cutover-success-list-text">See vehicle locations and statuses on the fleet dashboard map after install.</div>
                            <div className="cutover-success-list-text cutover-success-text">Install all your device(s) and keep them connected to maintain program participation status and get all the benefits and savings of DriveEasy Pro.</div>
                        </div>
                    </div>
                    <div className="row cutover-button-row">
                        <div className="col-sm-12 cutover-button-col">
                            <button className="cutover-button-back-to-policy" onClick={() => this.onClickExplore()}>Explore The Fleet Dashboard</button>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => ({
    loggedInUser: state.loggedInUser,
    policy: state.dshs.policy,
    eligibleProgram: state.dshs.eligibleProgram,
});

export default connect(
    mapStateToProps,
    DashboardStore.actionCreators,
)(CutoverSuccess as any);
